define('models/pages/schedule',[
    'jquery',
    'models/base/model',
    'models/base/collection',
    'lib/utils'
], function($, Model, Collection, utils) {
    'use strict';

    var msToHour = 1 / (1000 * 60 * 60);
    var msToDay = 1 / (1000 * 60 * 60 * 24);
    var oneDay = 1000 * 60 * 60 * 24;

    /*
        All params is integer

        loadCenter
        loadFromDate = loadCenter - loadRadius
        loadToDate = loadCenter + loadRadius
        loadRadius

        loadTreshold

        fromDate
        toDate
    */

    function timeToPos(time) {
        return (time * msToHour * 50 + time * msToDay * 5);
    }


    // Schedule

    var SchedulePageModel = Model.extend({
        urlPath: '/api/schedule',
        defaults: {
            loadRadius: oneDay * 7 * 1,
            loadTreshold: oneDay * 1,
            height: 275,
            fullWidth: 0,
            days: [],
            items: [],
            timerLeft: 0,
            tailHeight: 200,
            contentHeight: 200
        },
        constructor: function() {
            Model.apply(this, arguments);
            this.on('afterLoad', this.updateTimer);
        },
        dispose: function() {
            if (this.disposed) {
                return;
            }
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
            Model.prototype.dispose.apply(this, arguments);
        },
        getTimerLeft: function(fromDate, toDate) {
            var time = new Date();
            time = time.getTime();
            if ((fromDate < time) && (time < toDate)) {
                return timeToPos(time - fromDate);
            } else {
                return -1;
            }
        },
        updateTimer: function() {
            var _this = this;

            function updateTimerAction() {
                _this.set('timerLeft', _this.getTimerLeft(_this.get('fromDate'), _this.get('toDate')));
            }

            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }

            if (!this.get('loading')) {
                this.timerInterval = setInterval(updateTimerAction, 1000 * 60);

                updateTimerAction();
            }
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);

            var loadCenter = this.get('loadCenter');
            var loadRadius = this.get('loadRadius');

            params.fromDate = utils.fmtDate(loadCenter - loadRadius);
            params.toDate = utils.fmtDate(loadCenter + loadRadius);

            return params;
        },
        checkBounds: function(time) {
            var fromDate, toDate, loadTreshold, tresholdFromDate, tresholdToDate;

            fromDate = this.get('fromDate');
            loadTreshold = this.get('loadTreshold');

            if (!fromDate) {
                fromDate = time;
                toDate = time;
            } else {
                toDate = this.get('toDate');
            }

            tresholdFromDate = fromDate + loadTreshold;
            tresholdToDate = toDate - loadTreshold;

            return (time > tresholdFromDate && time < tresholdToDate);

        },
        timeToPosition: function(time) {
            return timeToPos(time - this.get('fromDate'));
        },
        positionToTime: function(left, scrollingRight) {
            var days = this.get('days');

            for (var i=0, l=days.length; i<l; i++) {
                if (days[i].left > left) {
                    if (scrollingRight) { --i; }
                    break;
                }
            }
            var res = new Date();

            if (i === l) {
                i--;
            }

            if (i>=0 && i<l) {
                res.setTime(days[i].id);
            }

            return res.getTime();
        },
        parse: function(data) {
            var curDay, i, il, j, jl, k, kl, hg, item, row, left, right, top, fromDate, toDate, hh;

            if (data.loadCenter) {
                data.fromDate = data.loadCenter - this.defaults.loadRadius;
                data.toDate = data.loadCenter + this.defaults.loadRadius;
                data.items = [];
                data.timerLeft = this.getTimerLeft(data.fromDate, data.toDate);

                console.log('data>>', data);
            }

            data.fromDate = utils.truncTime(new Date(data.fromDate)).getTime();
            data.toDate = utils.truncTime(new Date(data.toDate)).getTime();

            fromDate = this.get('fromDate');
            toDate = this.get('toDate');

            data.days = [];
            for (curDay = data.fromDate; curDay <= data.toDate; curDay += oneDay) {
                data.days.push({
                    id: curDay,
                    name: utils.fmtDisplayDate(curDay, false, true),
                    left: timeToPos(curDay - data.fromDate)
                });
            }


            if (data.items.length) {
                hh = 0;
                for (i=0, il=data.items.length; i<il; i++) {
                    row = data.items[i];
                    for (j=0, jl=row.items.length; j<jl; j++) {
                        item = row.items[j];

                        left = timeToPos(item.startTime - data.fromDate);
                        right = timeToPos(item.endTime - data.fromDate);

                        hg = row.hg;

                        if (!hg) {
                            row.hg = hg = [];
                        }

                        top = null;
                        for (k=0, kl=hg.length; k<kl; k++) {
                            if (hg[k].right < left) {
                                top = hg[k].top;
                                break;
                            }
                        }

                        if (top === null) {
                            if (hg.length) {
                                top = hg[hg.length-1].top + 30 + 8;
                            } else {
                                top = 0;
                            }

                            hg.push({
                                right: right,
                                top: top
                            });
                        } else {
                            hg[k].right = right;
                        }

                        item.receiveDate = utils.fmtDisplayDateTrade(item.receiveDate);
                        item.left = left;
                        item.top = top;
                        item.width = Math.max(right - left, 50);
                    }

                    row.height = row.hg[row.hg.length-1].top + 30 + 28 + 8 + 8;

                    hh = hh + row.height;
                }

                data.contentHeight = 200 + hh + (data.items.length - 1) * 19;
            } else {
                data.contentHeight = 200;
            }

            data.tailHeight = $(window).height() - data.contentHeight;
            data.fullWidth = 1205 * data.days.length;

            return data;
        }
    });

    return SchedulePageModel;
});
